import styles from "./reportsPage.module.css";

import { Header } from "../../../components/header/header";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { useEffect, useState } from "react";
import CheckListAPI from "../../../api/CheckListAPI";
import { Separator } from "../../../components/separator/separator";
import { downloadFile } from "../../../utils/downloadFile";

import { Text } from "../../../components/text/text";

export const ReportsPage = () => {
    const openPage = useOpenPage();

    const [files, setFiles] = useState([]);

    useEffect(() => {
        CheckListAPI
            .fetchReportsList(null)
            .then(setFiles)
            .catch(console.error);
    }, []);

    const onDownload = (filename) => {
        CheckListAPI
            .fetchReportDownloadLink(filename)
            .then((res) => downloadFile(res, filename))
            .catch(console.error);
    }

    return (
        <>
            <Header title="Отчеты" />

            {
                files && files.length > 0 ?
                    <div className={styles.files}>
                        {
                            files.map(data => (
                                <div className={styles.file} key={data.filename} onClick={() => onDownload(data.filename)}>
                                    <Text as="div" variant="body" className={styles.file_name} size={12} weight={700}>{`Отчет ${data.filename.split("_")[2] || ""}`}</Text>
                                    <Text as="div" variant="body" className={styles.file_format} size={40} weight={900}>{data.format}</Text>
                                </div>
                            ))
                        }
                    </div>
                    :
                    <div
                        style={
                            {
                                fontSize: "16px",
                                flex: "1 1 auto",
                                textAlign: "center",
                                marginTop: "10px",
                                color: "var(--app-secondary-text-color)",
                            }
                        }
                    >
                        Отчетов пока нет...
                    </div>
            }

            <Separator />

            <Button
                fixed
                text="Сгенерировать отчет"
                onClick={openPage(`add`)}
            />
        </>
    );
}